import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { TipoVehiculoModel } from '../../models/tipo-vehiculo.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoVehiculoService extends BaseService<TipoVehiculoModel>{

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Tipo vehiculo';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.tipoVehiculo}`;
   }
}
